import React from 'react';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import * as R from 'ramda';
import cx from 'classnames';
import PropTypes from 'prop-types';
var useStyles = makeStyles(function (theme) {
  var _hideContent;
  return {
    hideContent: (_hideContent = {}, _hideContent[theme.breakpoints.down('sm')] = {
      display: 'none'
    }, _hideContent),
    contentLabel: {
      color: theme.palette.text.primary,
      fontWeight: 'bold',
      fontSize: '14px'
    },
    label: {
      color: theme.palette.text.primary,
      fontSize: '14px'
    },
    disabled: {
      cursor: 'not-allowed',
      color: theme.palette.text.disabled,
      '&:hover': {
        color: theme.palette.text.disabled
      }
    }
  };
});
var Permissions = function Permissions(_ref) {
  var data = _ref.data,
    labels = _ref.labels,
    onCheck = _ref.onCheck;
  var classes = useStyles();
  return React.createElement(Grid, {
    container: true
  }, React.createElement(Grid, {
    item: true,
    container: true,
    xs: 12
  }, React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 4
  }, React.createElement(Typography, {
    variant: 'h6',
    className: classes.contentLabel,
    style: {
      paddingTop: 8
    }
  }, R.prop('permission')(labels))), React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 8
  }, React.createElement(Typography, {
    variant: 'h6',
    className: cx(classes.contentLabel, classes.hideContent),
    style: {
      paddingTop: 8
    }
  }, R.prop('definition')(labels)))), React.createElement(Grid, {
    item: true,
    container: true,
    xs: 12
  }, R.map(function (item) {
    return React.createElement(Grid, {
      item: true,
      container: true,
      xs: 12,
      key: item.id
    }, React.createElement(Grid, {
      item: true,
      xs: 12,
      md: 4
    }, React.createElement(FormControlLabel, {
      control: React.createElement(Checkbox, {
        name: 'checkedB',
        color: 'primary'
      }),
      label: React.createElement(Typography, {
        variant: 'h6',
        className: R.propOr(false, 'disabled')(item) ? classes.disabled : classes.label
      }, R.prop('label')(item)),
      checked: !!item.isSelected,
      disabled: R.propOr(false, 'disabled')(item),
      onChange: function onChange() {
        return onCheck(item.id);
      }
    })), React.createElement(Grid, {
      item: true,
      xs: 12,
      md: 8
    }, React.createElement(Typography, {
      variant: 'h6',
      className: cx(R.propOr(false, 'disabled')(item) ? classes.disabled : classes.label, classes.hideContent),
      style: {
        paddingTop: 8
      }
    }, R.prop('definition')(item))));
  })(data)));
};
Permissions.propTypes = process.env.NODE_ENV !== "production" ? {
  data: PropTypes.array,
  labels: PropTypes.object,
  setSelectedOptions: PropTypes.func,
  onCheck: PropTypes.func
} : {};
export default Permissions;